import { Box } from "@chakra-ui/react";
import BranchServicesTable, {
  renderArrivalRatesPerServiceCell,
} from "../tables/BranchServicesTable";
import ArrivalRatesPerServiceSummary from "./ArrivalRatesPerServiceSummary";
import ReportDataTable from "../../reports/ReportDataTable";

import { ARRIVAL_RATES_FREQUENCIES } from "../../../store/constants";
import { ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";
import { getArrivalRatesPerServiceRowsForScope } from "../../../store/arrivalRatesPerServiceExport";
import { buildArrivalRatesPerServiceInsights } from "../../../store/arrivalRatesPerServiceInsights";


const BranchServices = ({ data, renderConfig, onRenderConfigChange }) => {

  return (
    <Box>
      {data.map(({ branchName, servicesData, branchTotalArrivals }, branchIndex) => {
        const title = `${branchIndex + 1}. ${branchName}`;
        const branch = { branchName, servicesData, branchTotalArrivals };
        const insights = buildArrivalRatesPerServiceInsights(branch);
        const rows = renderConfig?.charts?.enabled ? insights.topChartServices : servicesData;

        return (
          <Box key={branchIndex}>
            <h2>{title}</h2>
            <ArrivalRatesPerServiceSummary branch={branch} />
            {renderConfig?.charts?.enabled ? (
              <>
                <h3>Top Service Trend Detail</h3>
                {rows.map((data, index) => {
                  return (
                    <BranchServicesTable
                      key={`${branchIndex}-${index}`}
                      index={index}
                      data={data}
                      branchIndex={branchIndex}
                      branchName={branchName}
                      frequency={ARRIVAL_RATES_FREQUENCIES.DAY}
                      renderConfig={renderConfig}
                      onRenderConfigChange={onRenderConfigChange}
                    />
                  );
                })}
              </>
            ) : (
              <Box className="arrivalRatesPerServiceUnifiedBlock" mt="16px" mb="24px">
                <ReportDataTable
                  columns={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
                  rows={getArrivalRatesPerServiceRowsForScope(
                    {
                      data: servicesData,
                      branchName,
                      scope: "Branch",
                    },
                    renderConfig
                  )}
                  renderConfig={renderConfig}
                  renderCell={renderArrivalRatesPerServiceCell}
                  presortedRows={true}
                  onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
                />
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
};

export default BranchServices;
